import React, { useEffect, useLayoutEffect, useReducer, useState } from "react";
import ReactDOM from "react-dom";
// import { logEvent } from "@Lib/analytics";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { fetchRecommendArticleChoice, fetchRecommendArticleRelated } from "@Services/api";
import cx from "classnames";
import styles from "./comparePageFeaturedRecommended.modules.less";
import HotVideo from "@Components/movie/HotVideo/index";
import EquipsSelect from "@Components/movie/Equips";
import { host } from "@Services/url";
import { article } from "@Api";
import { g4 } from "../../utils/helper";

const { fetchV3Articles, fetchEquipMovie } = article;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});


interface MODULEPROPS {
  title: string;
  imgSrc: string;
  titleClassName?: string;
  imgClassName?: string;
  model?: string; // 車款
  link: string;
  desc?: string;
  time?: string;
  [key: string]: any;
}

export interface IArticleData {
  /** 標題 */
  title: string;
  /** 封面圖 */
  thumb: string;
  /** 作者 */
  author: string;
  /** 跳轉 */
  link: string;
  /** 時間 */
  date: string;
  /** id */
  id: number;
  /** 埋点相关 */
  analytics: {
    articleId: string;
    articleType: string;
    authorId: string;
    brandIds: string;
    kindIds: string;
    modelYearIds: string;
    subArticleType: string;
  };
  /** 厂牌相关 */
  brandAndKind: any;
  /** 封面图 */
  cover: string;
  /** 介绍 */
  description: string;
  flag: string;
  /** xx小时 */
  formatTime: string;
  /** 完整的阅读量 */
  fullVisits: string;
  /** 点赞 */
  likes: string;
  middleThumb: string;
  /** 模块 */
  model: string;
  /** 播放时间 */
  playTime: string;
  /** 栏目 */
  tag: string;
  /** 2022-08-19 */
  time: string;
  /** 类型 */
  type: number;
  /** 次数 */
  views: number;
}

// 擴展后可封裝
const Module: React.FC<MODULEPROPS> = ({ title = "", imgSrc, titleClassName, imgClassName, model, link }) => {
  return (
    <a href={link} className={styles["module-box"]}>
      <div className={imgClassName ? imgClassName : styles["module-img-box"]}>
        <img src={imgSrc} alt={model ? model : title} className={styles["module-img"]} />
      </div>
      {/* 待擴展 */}
      <div className={cx(styles["module-title-box"], titleClassName)}>{!!title && title}</div>
    </a>
  );
};

interface FeaturedRecommendedProps {
  title: string;
  fetchFun: (params?: any) => Promise<any>;
  fetchString: string;
  fetchData: {
    limit?: number;
    type?: string;
    articleId?: string | undefined;
    relatedType?: string;
    [key: string]: any;
  };
  columns: number;
  fetchIdsCallback?: (pr: string[]) => void;
  show?: boolean;
  moreUrl?: string;
}

const FeaturedRecommended: React.FC<FeaturedRecommendedProps> = ({
  title = "精選推薦",
  fetchFun,
  fetchString,
  columns,
  fetchData,
  fetchIdsCallback,
  show = true,
  moreUrl = "",
}) => {
  if (!show) return <></>;

  const { data } = useQuery(
    fetchString,
    async () => {
      const res = await fetchFun(fetchData);
      if (res?.status === 12000) {
        if (fetchIdsCallback && Array.isArray(res?.data?.list)) {
          const idArr: string[] = res?.data.list.map((item) => item?.id);
          idArr.length !== 0 && fetchIdsCallback(idArr);
        }
        return res.data;
      }
    },
    { initialData: { list: [] } },
  );

  return (
    <section>
      {Array.isArray(data.list) && data.list.length !== 0 && (
        <div className={styles["featured-recommend-box"]}>
          <div className={styles["title"]}>
            {title}
            {moreUrl !== "" && (
              <a href={moreUrl} className='text-16 mt-4 font-normal m-0 text-[#666] hover:text-[#666]'>
                更多
              </a>
            )}
          </div>
          <div className={styles[`featured-recommend-container-${columns}`]}>
            {data.list.map((item, index) => (
              <Module key={index} title={item.title} imgSrc={item.thumb} model={item.model} link={item.link} />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

interface InitialState {
  news: boolean;
  compare: boolean;
  filterIds: string[];
  showRelatedArticle: boolean;
}

interface actionType {
  type: string;
  payload?: any;
}

const Content = () => {
  const initialState: InitialState = {
    news: false,
    compare: false,
    filterIds: [],
    showRelatedArticle: false,
  };

  const itemCss: any = {
    width: "205px",
    height: "115px",
    marginRight: "20px",
  };

  const reducer = (state: InitialState, action: actionType): InitialState => {
    switch (action.type) {
      case "isCompare":
        return { ...state, compare: true };

      case "isArticlePage":
        return { ...state, news: true };

      case "isShowRelatedArticle":
        return { ...state, showRelatedArticle: true };

      case "addId":
        return { ...state, filterIds: action.payload };

      default:
        return state;
    }
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [movieList, setMovieList] = useState<IArticleData[]>([]);
  const [listItem, setListItem] = useState<any[]>([]);
  const [expanded, setExpanded] = useState(false);

  let displayedTags: any =
    Array.isArray(window.tags) && window.tags.length > 0 ? (expanded ? window.tags : window.tags.slice(0, 6)) : [];

  useLayoutEffect(() => {
    const { pathname, search } = window.location;

    if (pathname.indexOf("photoModel-compare") !== -1 && search === "") {
      dispatch({ type: "isCompare" });
    } else if (pathname.indexOf("news") !== -1 || pathname.indexOf("trialrun") !== -1) {
      dispatch({ type: "isArticlePage" });
    }

    getCarList();
  }, []);

  const fetchIdsCallback = (ids: String[]): void => {
    dispatch({ type: "addId", payload: ids });

    Promise.resolve().then(() => {
      dispatch({ type: "isShowRelatedArticle" });
    });
  };

  const getCarList = async () => {
    try {
      const res = await fetchV3Articles({ limit: 10, type: "3" });
      if (res && res.status === 12000) {
        setMovieList(res.data.list);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getData = async () => {
    const res: any = await fetchEquipMovie({
      kindId: window.RELATED_KIND_IDS,
      kindInfo: 1,
    });

    if (res && res.status === 12000) {
      setListItem(res?.data?.list || []);
    }
  };

  useEffect(() => {
    if (window.RELATED_KIND_IDS && window.RELATED_KIND_IDS !== "") {
      getData();
    }
  }, [window.RELATED_KIND_IDS]);

  return (
    <>
      {state.compare ? (
        <QueryClientProvider client={queryClient}>
          <FeaturedRecommended
            title='精選推薦'
            fetchFun={fetchRecommendArticleChoice}
            fetchString='fetchRecommendArticleChoice'
            columns={5}
            fetchData={{
              limit: 30,
              position: "compare",
            }}
          />
        </QueryClientProvider>
      ) : (
        state.news && (
          <QueryClientProvider client={queryClient}>
            {displayedTags.length > 0 && (
              <div id={"ModelTags"} className={styles["tags-model-box"]}>
                <div className={styles["item"]}>
                  <p className={styles["title"]}>文章標籤</p>
                  {displayedTags.map((tag: string, index: number) => (
                    <a href={`/article/tag/${tag.replace(/ /g, "-")}`} key={index} className={styles["link"]}>
                      {tag}
                    </a>
                  ))}
                </div>
                {window.tags.length > 6 && (
                  <div className={styles["more"]} onClick={() => setExpanded(!expanded)}>
                    {expanded ? "收起" : "展開"}
                  </div>
                )}
              </div>
            )}

            <FeaturedRecommended
              title='相關話題'
              moreUrl={`${host.c}/Articles`}
              fetchFun={fetchRecommendArticleRelated}
              fetchString='fetchRecommendArticleRelatedCategory'
              columns={4}
              fetchData={{
                limit: 4,
                relatedType: "category",
                ...window.article,
              }}
              fetchIdsCallback={fetchIdsCallback}
            />
            {state.showRelatedArticle && (
              <FeaturedRecommended
                title='相關文章'
                moreUrl={`${host.c}/Articles`}
                fetchFun={fetchRecommendArticleRelated}
                fetchString='fetchRecommendArticleRelatedTag'
                fetchData={{
                  limit: 4,
                  relatedType: "tag",
                  filterIds: !!state.filterIds.length ? state.filterIds.join(',') : '',
                  ...window.article,
                }}
                columns={4}
              />
            )}

            <section className={styles["news-video-box"]}>
              <HotVideo
                itemCss={itemCss}
                iconCss={{ top: "88px" }}
                titleCss={{ marginBottom: "18px" }}
                boxCss={{ marginBottom: "0" }}
                scrollToNum={665}
                dataSource={{
                  title: "相關影片",
                  movies: movieList,
                }}
                moreHref={`${host.c}/photoMovie-index.html`}
                likeIconShow={false}
                type={2}
              />
            </section>

            {/* <section className={styles["equips-select-box"]}>
              {Array.isArray(listItem) &&
                listItem.length > 0 &&
                listItem.map((item, index) => (
                  <EquipsSelect
                    key={index}
                    title={`${item.kind.brandName || ""} ${item.kind.kindName || ""} ${item.kind.year || ""}配備詳解`}
                    navSource={[]}
                    dataSource={item.movies}
                  />
                ))}
            </section> */}
          </QueryClientProvider>
        )
      )}
    </>
  );
};

const $app = document.getElementById("compare-featured-recommend-articles");
!!$app && ReactDOM.render(<Content />, $app);
